export default __webpack_public_path__ + "static/media/icon-activity-folder.cdc23f2a.svg";